import Profile from 'components/profile';
import React from 'react';


export const InvestorsProfilePage = () => {
  return <Profile />;
};
